export enum ExportFileRangeType {
    LATEST_DAY = "LATEST_DAY",
    FULL_HISTORY = "FULL_HISTORY",
    SPECIFIC_RANGE = "SPECIFIC_RANGE",
}
